/**
 * @Description: 跳转iframe配置
 * @Date: 2019-10-18
 * @Modify:
 * @Author: lip-m
 */
import Layout from '@/components/layout/Index.vue'

export default [
  {
    path: '/iframe',
    component: Layout,
    children: [
      {
        path: ':linkUrl/:name?',
        // path: ':linkUrl/:name/:windowName?',
        component: () => import('@/views/iframe/Index'),
        meta: { title: '造价云管理平台', icon: 'home', noCache: true, keepAlive: false, auth: true }
      }
    ]
  }
]
